import styled from "@emotion/styled";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import ListItemIcon from "@mui/material/ListItemIcon";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  ListItemText,
} from "@mui/material";
import * as Yup from "yup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import ProfileService from "services/ProfileService";
import { AuthData } from "auth/AuthWarpper";
import NoData from "assets/noData.svg";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import axios from "axios";
import ImportService from "services/ImportService";
import WoodService from "services/WoodService";
import docEnabled from "assets/docEnabled.svg";
import docDisabled from "assets/docDisabled.svg";
import PaginationImport from "../Common/PaginationImport";
import CustomPagination from "../Common/CustomPagination";

const validationSchema = Yup.object({
  profileCode: Yup.string()
    .required("Profile Code is required")
    .max(50, "Profile Code must be less than 50 characters")
    .matches(
      /^[^\s]+(?: [^\s]+)*$/,
      "Profile Code is required and must not contain Extra spaces"
    ),
  profileName: Yup.string()
    .required("Profile Name is required")
    .max(50, "Profile Name must be less than 50 characters")
    .matches(
      /^[^\s]+(?: [^\s]+)*$/,
      "Profile Name is required and must not contain Extra spaces"
    ),
  profileAttributes: Yup.string().required("Attribute is required"),
  functionality: Yup.array()
    .min(1, "At least one item is required")
    .required("Functionality is required"),
});

const ViewWoodLog = (props) => {
  const { state } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const [options, setOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  let year = "";
  const [yearReload, setYearReload] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(7); // Num
  const [importData, setImportData] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState('');
  const [selectedFilter, setSelectedFilter] = useState("");
  const [pageSize, setPageSize] = useState(20);

  const paginate = (pageNumber, itemsPerPage) => {
    getApiData(pageNumber - 1, itemsPerPage, id, defaultFilter);
  };

  const handleViewLogDetails = (id) => {
    let routeName = "viewWoodDetails";
    navigate(`/${routeName}/${id}`);
  };

  
  const fetchData = async () => {
    try {
      const query = { ilHeaderId: id };
      const res = await ImportService.ExportAll(query);
  
      // Add UTF-8 BOM
      const BOM = '\uFEFF'; // UTF-8 BOM
      const csvContent = BOM + res.data; // Prepend BOM
  
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `export_wood_log_${id}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      setMessage(error?.response?.data?.message || error?.message || "Failed to export data");
      setOpenAlert(true);
      setSeverity("error");
    }
  };
  

  const logsDetails = {
    fileName: "",
    uploadedByUser: "",
    uploadStatus: "",
    comments: "",
    timestamp: "",
    success: "",
  };

  const [logsDetailsData, setLogsDetailsData] = useState(logsDetails);



  const handleChange = (event) => {
    // setFetchError(false);
    year = event.target.value;
    setYearReload(true);
  };

  const setColor = (status) => {
    switch (status) {
      case "Success":
        return "green";
      case "Failed":
      case "Fail":
      case "Error":
        return "red";
      default:
        return "black";
    }
  };

  const handleChangeFilter = (event) => {
    setSelectedFilter(event.target.value);
    if(event.target.value == 'Fail'){
      setDefaultFilter('Fail');
    } else if(event.target.value == 'Success') {
      setDefaultFilter('Success');
    } else {
      setDefaultFilter('');
    }
    if (event.target.value == "All") {
      getApiData(0, pageSize, id);
    } else if (event.target.value == "Success") {
      getApiData(0, pageSize, id, "Success");
    } else {
      getApiData(0, pageSize, id, "Fail");
    }
  };

  const { previousData, edit } = location.state || {};
  const { id } = useParams();

  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  const [formData, setFormData] = useState({
    profileCode: previousData?.profileCode || "",
    profileName: previousData?.profileName || "",
    profileAttributes: previousData?.attributes || "",
    isActive: previousData?.active == "Active" ? true : false || false,
    functionality: selected,
  });

  const getApiData = (pNumber, size, id, filter) => {
    setLoading(true);
    
    // Prepare query parameters
    const queryParams = { 
      id: id,
      pageNumber: pNumber,
      size: size
    };
    if (filter && filter !== "All") {
      queryParams.status = filter === "Fail" ? "Fail" : filter;
    }
    
    WoodService.fetchWoodLogs(queryParams)
      .then(res => {
        let resp = res?.data?.response;
        let logs = resp?.importWoodSupplierLogs || [];
        
        // Map API response to component format
        let mappedData = logs.map((item, index) => ({
          id: index + 1,
          permanentCode: item["permanent-code"],
          name: item["wood-supplier-name"],
          nationalId: item["national-id"],
          stateProvince: item["state"],
          town: item["town"],
          woodSupplierStatus: item["status"],
          operation: item["operation"],
          importStatus: item["import-status"],
          errorDescription: item["error-description"],
          iLdcID: item["wood-supplier-log-id"],
        }));
        
        setImportData(mappedData);
        setCurrentPage(pNumber); // Convert 0-based API page to 1-based UI page
        setItemsPerPage(size);
        setTotalItems(resp?.totalItems || mappedData.length);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching wood logs:", error);
        setImportData([]);
        setMessage(error?.response?.data?.message || error?.message || "Failed to fetch wood logs");
        setOpenAlert(true);
        setSeverity("error");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (location?.state) {
      setLogsDetailsData({
        fileName: location.state.fileName,
        uploadedByUser: location.state.uploadedBy,
        uploadStatus: location.state.uploadStatus,
        comments: location.state.comments,
        timestamp: location.state.timestamp || new Date().toLocaleString(),
        success: (location.state.success || 0) + "/" + (location.state.fail || 0),
      });
    } else {
      // Set dummy data if no state
      setLogsDetailsData({
        fileName: "wood_suppliers_import.csv",
        uploadedByUser: "admin@example.com",
        uploadStatus: "Completed",
        comments: "Wood supplier data import",
        timestamp: new Date().toLocaleString(),
        success: "0/0",
      });
    }
    if (id) {
      getApiData(0, pageSize, id);
    }
    if (location && location.pathname == "/addProfiles") {
      let p_name = formData.profileName;
      let p_attr = formData.profileAttributes;
      const result =
        mergeFirstCharacters(p_name) + mergeFirstCharacters(p_attr);
      const uniqueNumber = generateUniqueNumber();
      let numberStr = uniqueNumber.toString();
      if (numberStr.charAt(0) == "-") {
        numberStr = numberStr.replace(numberStr[0], "");
      }
      setFormData({
        ...formData,
        ["profileCode"]: `${result.toUpperCase()}${numberStr}`,
      });
    }
  }, [formData.profileName, formData.profileAttributes]);

  const mergeFirstCharacters = (str) => {
    const words = str.split(" ");
    const mergedCharacters = words.map((word) => word.charAt(0)).join("");
    return mergedCharacters;
  };

  function generateUniqueNumber() {
    const timestamp = new Date().getTime();
    const randomNumber = Math.floor(Math.random() * 1000000);
    const uniqueIdentifier = navigator.userAgent;
    const uniqueNumber = hashCode(timestamp + randomNumber + uniqueIdentifier);
    return uniqueNumber;
  }

  function hashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash &= hash; // Convert to 32bit integer
    }
    return hash;
  }

  useEffect(() => {
    const fetchFunctionalityOptions = async () => {
      try {
        // Simulate API call - in real implementation this would be ProfileService.getFuntionalityOptions()
        const dummyResponse = {
          data: {
            response: [
              { functionalityName: "Create Wood Supplier" },
              { functionalityName: "Update Wood Supplier" },
              { functionalityName: "Delete Wood Supplier" },
            ]
          }
        };

        if (edit === true) {
          setOptions([
            ...previousData.functionality,
            ...dummyResponse.data.response.filter(
              (option) =>
                !previousData.functionality.some(
                  (existingOption) =>
                    existingOption.functionalityName ===
                    option.functionalityName
                )
            ),
          ]);

          // Initialize selected countries with countryArr
          const selectedOptions = previousData.functionality.filter((option) =>
            dummyResponse.data.response.some(
              (selectedOption) =>
                selectedOption.functionalityName === option.functionalityName
            )
          );
          setSelected(selectedOptions);
          setFormData({
            ...formData,
            functionality: selectedOptions,
          });
        } else {
          setOptions(dummyResponse.data.response);
        }
      } catch (error) {
        console.error("Error fetching functionality options:", error);
      }
    };

    fetchFunctionalityOptions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        profileCode: formData.profileCode,
        profileName: formData.profileName,
        isActive: formData.isActive,
        profileAttribute: formData.profileAttributes,
        functionality: formData.functionality,
        createdByUser: user?.userName,
        modifiedByUser: user?.userName,
      };

      // Simulate API call
      setTimeout(() => {
        navigate("/manageProfiles");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      }, 1000);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        let newError = {};
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
        setSeverity("error");
        setLoading(false);
      }
    }
    setLoading(false);
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      setErrors({});
      await validationSchema.validate(formData, { abortEarly: false });

      const payload = {
        profileCode: formData.profileCode,
        profileName: formData.profileName,
        isActive: formData.isActive,
        profileAttribute: formData.profileAttributes,
        modifiedByUser: user.userName,
        profileId: id,
        functionality: formData.functionality,
      };

      // Simulate API call
      setTimeout(() => {
        navigate("/manageProfiles");
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
      }, 1000);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        let newError = {};
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
        });
        setErrors(newError);
      } else {
        console.error("An error occurred while submitting the form:", error);
        setSeverity("error");
        setMessage("An error occurred while submitting the form");
        setOpenAlert(true);
      }
    }
    setLoading(false);
  };

  return (
    <>
      <Layout title="Agri360 ESG Portal">
        <div style={{ paddingBottom: "140px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Heading>Import Wood Supplier</Heading>
            <Button
              sx={{
                borderRadius: 100,
                minWidth: 95,
                minHeight: 44,
                background: "#102A62",
              }}
              variant="contained"
              startIcon={<KeyboardBackspaceIcon />}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Box>
          <PaperContainer>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    File Name
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.fileName}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Uploaded By User
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.uploadedByUser}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "none" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Upload Status
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.uploadStatus}
                      name="profileCode"
                      onChange={handleChange}
                      disabled={true}
                    />
                    {errors.profileCode && (
                      <FormHelperText error={true}>
                        {errors.profileCode}
                      </FormHelperText>
                    )}
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Comments
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.comments}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Timestamp
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.timestamp}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    Success/Fail
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "100%" },
                        "& .MuiOutlinedInput-root": {
                          height: "50px",
                          "& fieldset": {
                            borderColor: "#102A63 !important", // Default border color
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#102A63 !important", // Hover border color
                            borderWidth: "1px",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#102A63", // Focused border color
                            borderWidth: "1px",
                          },
                          "&.Mui-disabled": {
                            backgroundColor: "#f5f5f7", // Background color for disabled state
                            "& input": {
                              color: "#000000", // Text color for disabled state
                              WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                              opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                              fontWeight: "600",
                              fontSize: "16px",
                            },
                            "& fieldset": {
                              borderColor: "transparent", // Optional: make border invisible when disabled
                            },
                          },
                        },
                      }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      value={logsDetailsData.success}
                      name="profileName"
                      onChange={handleChange}
                      disabled={true}
                    />
                    <FormHelperText error={true}>
                      {errors.profileName}
                    </FormHelperText>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </PaperContainer>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mt: 3,
            }}
          >
            <Box>
              <FormControl sx={{ m: 1, minWidth: { xs: 150, md: 300 } }}>
                <TextField
                  sx={{
                    width: { xs: "100%", md: "100%" },
                    "& .MuiOutlinedInput-root": {
                      height: "50px",
                      fontStyle: "normal",
                      fontWeight: "bold",
                      "& fieldset": {
                        borderColor: "#102A63 !important", // Default border color
                        borderWidth: "1px",
                      },
                      "&:hover fieldset": {
                        borderColor: "#102A63 !important", // Hover border color
                        borderWidth: "1px",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#102A63", // Focused border color
                        borderWidth: "1px",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#f5f5f7", // Background color for disabled state
                        "& input": {
                          color: "#000000", // Text color for disabled state
                          WebkitTextFillColor: "#000000", // Use -webkit-text-fill-color for WebKit browsers
                          opacity: 1, // Ensure opacity is set to 1 if you want it to appear solid
                          fontWeight: "600",
                          fontSize: "16px",
                        },
                        "& fieldset": {
                          borderColor: "transparent", // Optional: make border invisible when disabled
                        },
                      },
                    },
                  }}
                  select
                  value={selectedFilter}
                  onChange={handleChangeFilter}
                  // displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  label={selectedFilter ? "" : "Status"}
                >
                  <MenuItem value="All">
                    <b>All</b>
                  </MenuItem>
                  <MenuItem value="Success">
                    <b>Success </b>
                  </MenuItem>
                  <MenuItem value="Fail">
                    <b>Fail</b>
                  </MenuItem>
                </TextField>
              </FormControl>
            </Box>
            <Box>
              <Button
                sx={{
                  borderRadius: 2,
                  minWidth: 156,
                  minHeight: 44,
                  background: "#102A62",
                  marginTop: { xs: 1 },
                  marginLeft: { xs: 1 },
                }}
                startIcon={loading && <CircularProgress size={20} />}
                variant="contained"
                onClick={fetchData}
                disabled={loading}
              >
                Export All
              </Button>
            </Box>
          </Box>
          <Box>
            {importData?.length > 0 && (
              <div
                className="import-table-container"
                style={{ paddingTop: "20px" }}
              >
                <table className="import-table">
                  <thead>
                    <tr className="HierarchyHead">
                      <th>Permanent Code</th>
                      <th>Name</th>
                      <th>National ID</th>
                      <th>State/Province</th>
                      <th>Town</th>
                      <th>Wood Supplier Status</th>
                      <th>Operation</th>
                      <th>Import Status</th>
                      <th>Error Description</th>
                      <th>View Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importData.map((row, index) => (
                      <tr key={index} className="import-table-row">
                        <td>{row?.permanentCode}</td>
                        <td>{row.name}</td>
                        <td>{row.nationalId}</td>
                        <td>{row.stateProvince}</td>
                        <td>{row.town}</td>
                        <td>{row.woodSupplierStatus}</td>
                        <td>{row.operation}</td>
                        <td style={{ color: setColor(row?.importStatus) }}>
                          {row?.importStatus}
                        </td>
                        <td>{row.errorDescription}</td>
                        <td>
                          <p onClick={() => handleViewLogDetails(row.iLdcID)}>
                            <img
                              style={{ cursor: "pointer" }}
                              src={docEnabled}
                            />
                          </p>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {importData?.length == 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "40px",
                }}
              >
                <img src={NoData} style={{ height: "100px" }} alt="No Data" />
                <p>No Data Available</p>
              </Box>
            )}
          </Box>
        </div>
        <Box>
          {importData?.length > 0 && (
            <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
              {importData && (
                <CustomPagination
                itemsPerPage={itemsPerPage}
                setItemsPerPage = {(v)=>setItemsPerPage(v)}
                totalItems={totalItems}
                paginate={paginate}
                currentPage={currentPage}
                />
              )}
            </div>
          )}
        </Box>
      </Layout>
    </>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;

export default ViewWoodLog;
